module.exports = __webpack_public_path__ + "img/truck.5a6ca6b9.svg";